import { Container, Stack, Text, Title } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import { useMutation } from 'urql';
import { getErrorMessage } from '@/lib/error-message';
import { FlowTemplateForm, emptyFlowTemplateValues, toFlowTemplateInput } from './-components/flow-template-form';
import { InsertFlowTemplateMutation } from './-components/graphql';

export const Route = createFileRoute('/_authed/system/flow-templates/new')({
  component: SystemNewFlowTemplatePage,
});

function SystemNewFlowTemplatePage() {
  const [, runInsert] = useMutation(InsertFlowTemplateMutation);

  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <div>
          <Title order={1}>New Flow Template</Title>
          <Text c="dimmed" mt="xs">
            Create a reusable flow template with configurable variables
          </Text>
        </div>
        <FlowTemplateForm
          initialValues={emptyFlowTemplateValues}
          submitLabel="Create"
          onSubmit={async (values) => {
            const result = await runInsert({ object: { ...toFlowTemplateInput(values) } });

            return result.error ? getErrorMessage(result.error, 'Failed to create flow template') : null;
          }}
        />
      </Stack>
    </Container>
  );
}
